/* eslint-disable indent */
import React from 'react'
import { Card, Form, Row, Col, Button } from 'react-bootstrap'
import { getTranslation } from '../services/translations'

const ScoutCommentsCard = ({
  scoutComments,
  scoutCommentAuthor,
  scoutCommentUpdatedAt,
  handleScoutCommentsChange,
  saveScoutComments,
  isSavingScoutComment,
  hasUnsavedScoutComment,
  candidates,
  selectedCandidate,
  handleCandidateSelect,
  updateCandidate,
  canAddToList = true,
  lang,
}) => {
  const t = key => getTranslation(lang, key)

  return (
    <Card
      style={{
        backgroundColor: '#2C2F33',
        color: '#FFFFFF',
        borderColor: '#1E2124',
      }}
    >
      <Card.Header
        style={{
          backgroundColor: '#1a1d21',
          color: '#FFFFFF',
          fontSize: '0.8rem',
          padding: '6px 12px',
        }}
      >
        {t('scoutComments')}
      </Card.Header>
      <Card.Body>
        <Form.Group className="d-flex flex-column">
          <Form.Control
            as="textarea"
            rows={4}
            value={scoutComments}
            onChange={handleScoutCommentsChange}
            placeholder={t('enterScoutComments')}
            style={{
              backgroundColor: '#23272A',
              color: '#FFFFFF',
              border: '1px solid #1E2124',
              fontSize: '0.875rem',
            }}
          />
        </Form.Group>

        <Button
          variant="success"
          size="sm"
          className="mt-2"
          onClick={saveScoutComments}
          disabled={!hasUnsavedScoutComment || isSavingScoutComment}
        >
          {isSavingScoutComment ? t('saving') : t('saveComment')}
        </Button>

        {scoutCommentAuthor && (
          <small className="text-muted d-block mt-2">
            {t('commentWrittenBy')}: {scoutCommentAuthor}
            {scoutCommentUpdatedAt && (
              <>
                {' · '}
                {new Date(scoutCommentUpdatedAt).toLocaleString(
                  lang === 'en' ? 'en-GB' : 'fi-FI',
                  { dateStyle: 'short', timeStyle: 'short' }
                )}
              </>
            )}
          </small>
        )}

        {/* Lisää listalle */}
        {canAddToList && candidates && candidates.length > 0 && (
          <Form.Group controlId="formCandidateSelect" className="mt-3">
            <Row className="g-2 align-items-center">
              <Col xs={8}>
                <Form.Control
                  as="select"
                  value={selectedCandidate}
                  onChange={handleCandidateSelect}
                  size="sm"
                  style={{
                    backgroundColor: '#23272A',
                    color: '#FFFFFF',
                    fontSize: '0.8rem',
                  }}
                >
                  <option value="">{t('selectList')}</option>
                  {candidates.map(candidate => {
                    const candidateId = candidate.id || candidate._id
                    const label =
                      candidate.Competition && candidate.Season
                        ? `${candidate.Competition}${candidate.Season}${
                            candidate.Position ? ' ' + candidate.Position : ''
                          }`
                        : candidate.Name
                    return (
                      <option key={candidateId} value={candidateId}>
                        {label}
                      </option>
                    )
                  })}
                </Form.Control>
              </Col>
              <Col xs={4}>
                <Button
                  variant="success"
                  size="sm"
                  onClick={updateCandidate}
                  style={{
                    backgroundColor: '#43B581',
                    borderColor: '#43B581',
                    width: '100%',
                    fontSize: '0.8rem',
                  }}
                >
                  {t('addToList')}
                </Button>
              </Col>
            </Row>
          </Form.Group>
        )}
      </Card.Body>
    </Card>
  )
}

export default ScoutCommentsCard
